// What the loading card says when a load step fails, so a failure never leaves a blank page.
//
//   failedLoad('the sandbox', err) ─► 'Could not load the sandbox: <reason>. Reload the page to try again.'
//
// A reload is the honest advice: the usual cause is a page that outlived a redeploy and asks for a
// chunk whose hashed file name is gone.

import type { LoadProgress } from '../data/index.ts';

const RELOAD_HINT = 'Reload the page to try again.';

export function failedLoad(what: string, err: unknown): LoadProgress {
  const reason = err instanceof Error ? err.message : String(err);
  return { done: 0, total: 1, label: `Could not load ${what}: ${reason}. ${RELOAD_HINT}` };
}
